import { useEffect, useState } from "react";
import { CustomTable } from "../../../../components";
import { useSelector } from "react-redux";
import moment from "moment";
import { filterResponsesOnlyLastEntry } from "../../../../redux/helpers";
import { formatingHeadersCemex, formatingHeadersColgateMontacarga } from "../../../../redux/helpersHeadersPerProyect";
import { filterResponsesLastEntryPerDateCemex, aggregateColgateMontacargaByMatricula } from "../../../../redux/helperResponsesPerProyect";

//DEV | PROD
const COLGATEMONTECARGA = ["-", "6a84b33b0d2cf5f15685e226"]

export const TrainingTablevt = ({ dateRange, hasFilter }) => {
    const { arrayData } = useSelector((state) => state.table);
    const { responses, proyectSelected } = useSelector((state) => state.vrtSlice);

    const [headers, setHeaders] = useState()
    const [dataTable, setComponentDataTable] = useState([])

    useEffect(() => {

        if (proyectSelected === "66fafd1d92bbc20883798c43") {
            // [para proyecto de CEMEX]
            console.log("sisi")
            setHeaders(formatingHeadersCemex(responses, "66fafd1d92bbc20883798c43"))
            setComponentDataTable(filterResponsesLastEntryPerDateCemex(arrayData))
        }
        if (proyectSelected === "67367c71fa5b23562aee086c") {
            console.log("no")

            // [para proyecto de Fresnillo-amacice]
            setHeaders(formatingHeadersCemex(responses, "67367c71fa5b23562aee086c"))
            setComponentDataTable(filterResponsesLastEntryPerDateCemex(arrayData))
        }
        else if (COLGATEMONTECARGA.includes(proyectSelected)) {
            console.log("COLGATE MONTACARGA")
            setHeaders(formatingHeadersColgateMontacarga(proyectSelected))
            setComponentDataTable(aggregateColgateMontacargaByMatricula(arrayData))
        }
        else {
            console.log("otr")

            setHeaders(formatingHeadersCemex(responses))
            setComponentDataTable(filterResponsesOnlyLastEntry(arrayData))
        }
    }, [responses, arrayData, proyectSelected])

    const [initialDate, endDate] = dateRange && hasFilter ? dateRange : [];
    const arrayDateWDates = dataTable.map((user) => ({ ...user, Fecha_y_hora: moment(user.Fecha_y_hora, "DD/MM/YYYY hh:mm:ss A") }));
    const filterByDate = arrayDateWDates.filter((user) => user.Fecha_y_hora >= initialDate && user.Fecha_y_hora <= endDate);
    const stringDate = filterByDate.map((user) => ({
        ...user,
        Fecha_y_hora: moment(user.Fecha_y_hora, "ddd MMM DD YYYY hh:mm:ss").format("DD/MM/YYYY hh:mm:ss A"),
    }));

    return (
        <div className="h-full p-4">
            <div className="h-full ">
                <CustomTable data={hasFilter ? stringDate : dataTable} columns={headers} />
            </div>
        </div>
    );
};
